import {
  ArrowForwardRounded,
  ContentCopyRounded,
  DateRangeRounded,
  DeleteForeverRounded,
  LockClockRounded,
  MarkChatUnreadRounded,
  MenuRounded,
  OpenInNewRounded,
  RefreshRounded,
  ScreenshotRounded,
} from "@mui/icons-material";
import { Box, Chip, Divider } from "@mui/material";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";

import useFirebase from "../../../config/context/firebaseContext";
import useMainState from "../../../config/context/mainStateContext";
import useModal from "../../../config/context/modalContext";

import SwitchMain from "../../../components/InputMain/SwitchMain";
import MainText from "../../../components/MainText";
import PageHeader from "../../../components/PageHeader";

import { BannerItemType } from "../../../types/common";

import { GreyPallet } from "../../../config/styles";
import { CustomBox } from "./styles";

export default function AdminRemoteSettingsPage() {
  const navigate = useNavigate();

  const { pushAlert } = useModal();
  const { setShowSideMenuDrawer } = useMainState();
  const { getConfig, forceRefreshConfigs, functions } = useFirebase();

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
          title="Conf. Remotas"
          rightIcon={<RefreshRounded />}
          onRightAction={() => forceRefreshConfigs()}
        />

        {/* Bus */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Ônibus
          </MainText>
        </Box>

        <SwitchMain
          disabled={true}
          name="Parada Favorita"
          small={"Selecionar e exibição de ônibus na Parada Favorita"}
          checked={getConfig("enabled_favorite_stop") as boolean}
          onChange={() => {}}
        />

        <SwitchMain
          disabled={true}
          name="Horários"
          small={"Exibir horarios de saída dos ônibus"}
          checked={getConfig("enabled_departs") as boolean}
          onChange={() => {}}
        />

        {/* Spott */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Spott
          </MainText>
        </Box>

        <SwitchMain
          disabled={true}
          name="Spott"
          small={"Botão do 'Spott' na Barra de Navegação e no Menu Lateral"}
          checked={getConfig("enabled_spott") as boolean}
          onChange={() => {}}
        />

        <SwitchMain
          disabled={true}
          name="Enviar Spott"
          small={"Botão de 'Enviar Spott' na página dos Spotts"}
          checked={getConfig("enabled_send_spott") as boolean}
          onChange={() => {}}
        />

        <SwitchMain
          disabled={true}
          name="Filtro Spott"
          small={"Filtros de 'Hoje, Ontem e Semana' na página dos Spotts"}
          checked={getConfig("enabled_user_spott_filter") as boolean}
          onChange={() => {}}
        />

        <CustomBox>
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} mb={2}>
            <MainText size="caption" color="regular">
              Número de Spotts
            </MainText>

            <MainText size="body" color="regular">
              {getConfig("number_spott_posts") as number}
            </MainText>
          </Box>

          <MainText size="small" color="regular">
            Número de postagens mais recentes carregadas quando o 'Filtro Spott' está desativado
          </MainText>
        </CustomBox>

        {/* Rating */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Rating
          </MainText>
        </Box>

        <SwitchMain
          disabled={true}
          name="Avaliação"
          small={"Botão da 'Avaliação dos Professores' na Barra de Navegação"}
          checked={getConfig("enabled_rating") as boolean}
          onChange={() => {}}
        />

        <CustomBox>
          <Box mb={1} sx={{ lineBreak: "anywhere" }}>
            <MainText size="caption" color="regular">
              {getConfig("rating_prof_url") as string}
            </MainText>
          </Box>

          <MainText size="small" color="regular">
            URL dos dados de Avaliação dos Professores
          </MainText>
        </CustomBox>

        <CustomBox>
          <Box mb={1} sx={{ lineBreak: "anywhere" }}>
            <MainText size="caption" color="regular">
              {getConfig("rating_comp_url") as string}
            </MainText>
          </Box>

          <MainText size="small" color="regular">
            URL dos dados de Avaliação dos Componentes
          </MainText>
        </CustomBox>

        {/* Chat */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Chat
          </MainText>
        </Box>

        <SwitchMain
          disabled={true}
          name="Chat"
          small={"Exibir página de 'Chats' no Menu"}
          checked={getConfig("enabled_chat") as boolean}
          onChange={() => {}}
        />

        <SwitchMain
          disabled={true}
          name="Criar Chat"
          small={"Botão de Criar Novo Chat na página de Chats"}
          checked={getConfig("enabled_chat_create") as boolean}
          onChange={() => {}}
        />

        {/* Banners */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Banners
          </MainText>
        </Box>

        {(getConfig("banner_list") as BannerItemType[]).map((item) => (
          <CustomBox key={item.id}>
            <Box mt={1} mb={2} gap={1} display={"flex"} flexWrap={"wrap"}>
              <Chip icon={<ScreenshotRounded />} label={item.screen} />
              <Chip icon={<MarkChatUnreadRounded />} label={item.type} />
              <Chip icon={<LockClockRounded />} label={item.persist ? "persist" : "not-persist"} />
              <Chip
                icon={<DeleteForeverRounded />}
                label={item.dimissable ? "dimissable" : "not-dimissable"}
              />
              <Chip
                icon={<DateRangeRounded />}
                label={
                  item?.active
                    ? `${DateTime.fromMillis(item?.active.start).toFormat(
                        "dd/LL/y"
                      )} > ${DateTime.fromMillis(item?.active.end).toFormat("dd/LL/y")}`
                    : null
                }
              />
            </Box>

            <MainText size="body" color="regular">
              {item.text}
            </MainText>

            {item.action ? (
              <Box sx={{ lineBreak: "anywhere" }}>
                <Divider sx={{ my: 1 }} />

                <Box
                  display={"flex"}
                  justifyContent={"start"}
                  alignItems={"center"}
                  gap={1}
                  color={GreyPallet.Regular}
                >
                  {item?.action?.type === "external-link" ? (
                    <OpenInNewRounded color="inherit" />
                  ) : item?.action?.type === "clipboard" ? (
                    <ContentCopyRounded color="inherit" />
                  ) : (
                    <ArrowForwardRounded color="inherit" />
                  )}
                  <Box>
                    <MainText size="body" color="regular">
                      {item?.action?.text} ({item?.action?.type})
                    </MainText>

                    <MainText size="small" color="regular">
                      {item?.action?.content}
                    </MainText>
                  </Box>
                </Box>
              </Box>
            ) : null}
          </CustomBox>
        ))}

        <SwitchMain
          disabled={true}
          name="Limpar Banners"
          small={
            "TODO: Limpar banners. Talvez alterar para uma abordagem de ID sendo um Timestamp onde o usuário vai ver se a ultima limpeza q ele fez é anterior a nova limpeza que a onfig está informando"
          }
          checked={getConfig("banner_clear") as boolean}
          onChange={() => {}}
        />

        {/* Cafeteria */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Lanchonetes
          </MainText>
        </Box>

        <SwitchMain
          disabled={true}
          name="Opções de Lanchonetes"
          small={"Exibir botões de lanchonetes na aba de cardápio e no Menu Lateral"}
          checked={getConfig("enabled_cafeteria") as boolean}
          onChange={() => {}}
        />

        <SwitchMain
          disabled={true}
          name="Pagamentos no APP"
          small={"TODO: Permitir pagamentos via PIX no aplicativo"}
          checked={getConfig("enabled_cafeteria") as boolean}
          onChange={() => {}}
        />

        {/* Outros */}

        <Box mb={2}>
          <MainText size="body" color="black">
            Outros
          </MainText>
        </Box>

        <SwitchMain
          disabled={true}
          name="Banner de Update"
          small={"Exibir o banner de 'Nova Versão Disponível, Deseja Atualizar?'"}
          checked={getConfig("enabled_banner_update") as boolean}
          onChange={() => {}}
        />

        <CustomBox>
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <MainText size="caption" color="regular">
              Útima versão Web
            </MainText>

            <MainText size="body" color="regular">
              {getConfig("latest_web_version") as number}
            </MainText>
          </Box>
        </CustomBox>

        <CustomBox>
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <MainText size="caption" color="regular">
              Útima versão Mobile
            </MainText>

            <MainText size="body" color="regular">
              {getConfig("latest_mobile_version") as number}
            </MainText>
          </Box>
        </CustomBox>
      </Box>
    </Box>
  );
}
